import SelectOption from '@/models/interface/SelectOption'
import SystemDashboardAction from '@/models/SystemDashboardAction'

export default class SpecialGroupFilter extends SystemDashboardAction {
  // Target Property to be changed or event name
  public target: string = 'filters'

  // Unique key for the action
  public key: string = 'special_group'

  // Label for the action
  public label: string = 'Show'

  // Options for the action if applicable
  public options: SelectOption[] = [
    new SelectOption('All', 'all'),
    new SelectOption('MLB Only', 'mlb_only'),
    new SelectOption('Non MLB', 'not_mlb'),
  ]
}
